import { ConfigPage } from '@/Admin/Config/ConfigPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/config/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ConfigPage />
}